import BaseLayer from "./BaseLayer";
import {getPrefixedUrl} from "../../../utils/utils";
import {drawCircle, drawLine, mapMotorToCanvas} from "../utils/map_utils";
import {Grid, Stack} from "@mui/material";
import {zProfileFolderPath} from "../../../utils/const";

class Dicy extends BaseLayer {
    id = "dicy";
    label = "Dicy";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {y_fields, tile_height, uperpixel, loc_on_machine, bucket_name, tile_viewer_path} = this.props.slide;
        let {dicy, textSize, deviceSettings, textColor, tileFlag} = this.props;
        Object.values(dicy).forEach(val => {
            let xPosition = parseInt(val["motorPosX"]);
            let yPosition = parseInt(val["motorPosY"]);
            let {x, y} = mapMotorToCanvas(xPosition, yPosition, this.props.slide,
                {device_settings: deviceSettings});
            x = x + 150;
            if (tileFlag['reverseYTileOrder']['flagY'])
                y = y_fields * tile_height * uperpixel - y + 130;
            else
                y = y + 130;

            let circleColor = "#ff8c00";
            if (val['isAutoThresh']) {
                circleColor = "#00FFFF";
                y = y - 100;
            }

            drawLine(x, y, 1, this.layer.getSource(), val["index"], 10,
                "#E9D6C5", "", textColor, textSize);
            drawLine(x, y + 30, 1, this.layer.getSource(), "T% " +
                parseFloat(val["tissuePercent"]).toFixed(2), 10, "#E9D6C5", "", textColor, textSize);
            let link1 = getPrefixedUrl(`debug/zprofile/${val["tissueImgPath"]}`, this.props.slide, true);
            let link2 = getPrefixedUrl(`debug/zprofile/${val["nonTissueImgPath"]}`, this.props.slide, true);
            let folderLink = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                zProfileFolderPath + val["folder"];
            let popupText = (
                <Stack>
                    <Grid>
                        {"Tissue % : " + parseFloat(val["tissuePercent"]).toFixed(2)}
                        <a href={folderLink}>{" [Folder] "}</a>
                    </Grid>
                    <Grid>
                        <a href={link1} target={"_blank"}>{"[Tissue Img] "}</a>
                        <a href={link2} target={"_blank"}>{" [Thresholded Img]"}</a>
                    </Grid>
                </Stack>
            );
            drawCircle(x, y, 25, this.layer.getSource(), "",
                6, circleColor, popupText, textColor);
        });
        resolve();
    });
}

export default Dicy;